// AUTO-GENERATED by scripts/generate-team-branding.mjs. Do not edit.
export type TeamBrandAsset = { path: string; contentDuplicateOf: string | null };
export type TeamBrandRecord = {
  cfbdId: number; school: string; abbreviation: string;
  colors: { primary: string | null; secondary: string | null };
  contrast: { primary: { foreground: string; ratio: number } | null; secondary: { foreground: string; ratio: number } | null };
  assets: { svg: TeamBrandAsset | null; themedPng: TeamBrandAsset | null; basePng: TeamBrandAsset | null };
  reviewStatus: "approved" | "legacy-approved" | "needs-review" | "rejected";
  presentation: { outline: "adaptive" | "none"; backgroundOverride: string | null; approvedOverride: boolean; overrideReason: string | null };
};

export const generatedTeamBranding: Readonly<Record<number, TeamBrandRecord>> = {
  "2": {
    "cfbdId": 2,
    "school": "Auburn",
    "abbreviation": "AUB",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "5": {
    "cfbdId": 5,
    "school": "UAB",
    "abbreviation": "UAB",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/5.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/5-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/5.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "6": {
    "cfbdId": 6,
    "school": "South Alabama",
    "abbreviation": "USA",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/6.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/6-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/6.png",
        "contentDuplicateOf": "6-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "8": {
    "cfbdId": 8,
    "school": "Arkansas",
    "abbreviation": "ARK",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/8.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/8-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/8.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "9": {
    "cfbdId": 9,
    "school": "Arizona State",
    "abbreviation": "ASU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/9.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/9-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/9.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "12": {
    "cfbdId": 12,
    "school": "Arizona",
    "abbreviation": "ARIZ",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/12.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/12-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/12.png",
        "contentDuplicateOf": "12-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "18": {
    "cfbdId": 18,
    "school": "Unresolved CFBD team 18",
    "abbreviation": "18",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/18.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "21": {
    "cfbdId": 21,
    "school": "San Diego State",
    "abbreviation": "SDSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/21.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/21-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/21.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "23": {
    "cfbdId": 23,
    "school": "San Jose State",
    "abbreviation": "SJSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": null,
      "themedPng": {
        "path": "/assets/logos/23-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/23.png",
        "contentDuplicateOf": "23-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "24": {
    "cfbdId": 24,
    "school": "Stanford",
    "abbreviation": "STAN",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/24.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/24-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/24.png",
        "contentDuplicateOf": "24-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "25": {
    "cfbdId": 25,
    "school": "California",
    "abbreviation": "CAL",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/25.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/25-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/25.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "26": {
    "cfbdId": 26,
    "school": "UCLA",
    "abbreviation": "UCLA",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/26.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/26-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/26.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "29": {
    "cfbdId": 29,
    "school": "Unresolved CFBD team 29",
    "abbreviation": "29",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/29.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "30": {
    "cfbdId": 30,
    "school": "USC",
    "abbreviation": "USC",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/30.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/30-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/30.png",
        "contentDuplicateOf": "30-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "32": {
    "cfbdId": 32,
    "school": "Unresolved CFBD team 32",
    "abbreviation": "32",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/32.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "36": {
    "cfbdId": 36,
    "school": "Colorado State",
    "abbreviation": "CSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/36.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/36-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/36.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "38": {
    "cfbdId": 38,
    "school": "Colorado",
    "abbreviation": "COLO",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/38.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/38-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/38.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "40": {
    "cfbdId": 40,
    "school": "Unresolved CFBD team 40",
    "abbreviation": "40",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/40.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "41": {
    "cfbdId": 41,
    "school": "UConn",
    "abbreviation": "CONN",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/41.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/41-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/41.png",
        "contentDuplicateOf": "41-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "43": {
    "cfbdId": 43,
    "school": "Unresolved CFBD team 43",
    "abbreviation": "43",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/43.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "47": {
    "cfbdId": 47,
    "school": "Unresolved CFBD team 47",
    "abbreviation": "47",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/47.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "48": {
    "cfbdId": 48,
    "school": "Unresolved CFBD team 48",
    "abbreviation": "48",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/48.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "52": {
    "cfbdId": 52,
    "school": "Florida State",
    "abbreviation": "FSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/52.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/52-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/52.png",
        "contentDuplicateOf": "52-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "53": {
    "cfbdId": 53,
    "school": "Unresolved CFBD team 53",
    "abbreviation": "53",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/53.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "55": {
    "cfbdId": 55,
    "school": "Unresolved CFBD team 55",
    "abbreviation": "55",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/55.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "57": {
    "cfbdId": 57,
    "school": "Florida",
    "abbreviation": "FLA",
    "colors": {
      "primary": "#0021A5",
      "secondary": "#FA4616"
    },
    "contrast": {
      "primary": {
        "foreground": "#ffffff",
        "ratio": 11.93
      },
      "secondary": {
        "foreground": "#000000",
        "ratio": 5.95
      }
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/57.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/57-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/57.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "58": {
    "cfbdId": 58,
    "school": "South Florida",
    "abbreviation": "USF",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/58.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/58-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/58.png",
        "contentDuplicateOf": "58-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "59": {
    "cfbdId": 59,
    "school": "Georgia Tech",
    "abbreviation": "GT",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/59.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/59-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/59.png",
        "contentDuplicateOf": "59-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "61": {
    "cfbdId": 61,
    "school": "Georgia",
    "abbreviation": "UGA",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/61.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/61-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/61.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "62": {
    "cfbdId": 62,
    "school": "Hawaii",
    "abbreviation": "HAW",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/62.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/62-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/62.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "65": {
    "cfbdId": 65,
    "school": "Unresolved CFBD team 65",
    "abbreviation": "65",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/65.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "66": {
    "cfbdId": 66,
    "school": "Iowa State",
    "abbreviation": "ISU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/66.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/66-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/66.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "67": {
    "cfbdId": 67,
    "school": "Unresolved CFBD team 67",
    "abbreviation": "67",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/67.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "68": {
    "cfbdId": 68,
    "school": "Boise State",
    "abbreviation": "BSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/68.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/68-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/68.png",
        "contentDuplicateOf": "68-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "70": {
    "cfbdId": 70,
    "school": "Unresolved CFBD team 70",
    "abbreviation": "70",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/70.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "75": {
    "cfbdId": 75,
    "school": "Unresolved CFBD team 75",
    "abbreviation": "75",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/75.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "77": {
    "cfbdId": 77,
    "school": "Northwestern",
    "abbreviation": "NU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/77.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/77-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/77.png",
        "contentDuplicateOf": "77-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "80": {
    "cfbdId": 80,
    "school": "Unresolved CFBD team 80",
    "abbreviation": "80",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/80.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "81": {
    "cfbdId": 81,
    "school": "Unresolved CFBD team 81",
    "abbreviation": "81",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/81.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "84": {
    "cfbdId": 84,
    "school": "Indiana",
    "abbreviation": "IU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/84.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/84-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/84.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "87": {
    "cfbdId": 87,
    "school": "Notre Dame",
    "abbreviation": "ND",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/87.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/87-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/87.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "90": {
    "cfbdId": 90,
    "school": "Unresolved CFBD team 90",
    "abbreviation": "90",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/90.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "95": {
    "cfbdId": 95,
    "school": "Unresolved CFBD team 95",
    "abbreviation": "95",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/95.svg",
        "contentDuplicateOf": "18.svg"
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "96": {
    "cfbdId": 96,
    "school": "Kentucky",
    "abbreviation": "UK",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/96.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/96-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/96.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "97": {
    "cfbdId": 97,
    "school": "Louisville",
    "abbreviation": "LOU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/97.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/97-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/97.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "98": {
    "cfbdId": 98,
    "school": "Western Kentucky",
    "abbreviation": "WKU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/98.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/98-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/98.png",
        "contentDuplicateOf": "98-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "99": {
    "cfbdId": 99,
    "school": "LSU",
    "abbreviation": "LSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/99.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/99-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/99.png",
        "contentDuplicateOf": "99-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "101": {
    "cfbdId": 101,
    "school": "Unresolved CFBD team 101",
    "abbreviation": "101",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/101.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "103": {
    "cfbdId": 103,
    "school": "Boston College",
    "abbreviation": "BC",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/103.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/103-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/103.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "107": {
    "cfbdId": 107,
    "school": "Unresolved CFBD team 107",
    "abbreviation": "107",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/107.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "108": {
    "cfbdId": 108,
    "school": "Unresolved CFBD team 108",
    "abbreviation": "108",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/108.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "109": {
    "cfbdId": 109,
    "school": "Unresolved CFBD team 109",
    "abbreviation": "109",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/109.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "113": {
    "cfbdId": 113,
    "school": "UMass",
    "abbreviation": "MASS",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/113.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/113-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/113.png",
        "contentDuplicateOf": "113-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "114": {
    "cfbdId": 114,
    "school": "Unresolved CFBD team 114",
    "abbreviation": "114",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/114.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "120": {
    "cfbdId": 120,
    "school": "Maryland",
    "abbreviation": "MD",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/120.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/120-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/120.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "121": {
    "cfbdId": 121,
    "school": "Unresolved CFBD team 121",
    "abbreviation": "121",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/121.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "125": {
    "cfbdId": 125,
    "school": "Unresolved CFBD team 125",
    "abbreviation": "125",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/125.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "126": {
    "cfbdId": 126,
    "school": "Unresolved CFBD team 126",
    "abbreviation": "126",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/126.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "127": {
    "cfbdId": 127,
    "school": "Michigan State",
    "abbreviation": "MSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/127.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/127-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/127.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "130": {
    "cfbdId": 130,
    "school": "Michigan",
    "abbreviation": "MICH",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/130.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/130-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/130.png",
        "contentDuplicateOf": "130-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "131": {
    "cfbdId": 131,
    "school": "Unresolved CFBD team 131",
    "abbreviation": "131",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/131.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "134": {
    "cfbdId": 134,
    "school": "Unresolved CFBD team 134",
    "abbreviation": "134",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/134.svg",
        "contentDuplicateOf": "29.svg"
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "135": {
    "cfbdId": 135,
    "school": "Minnesota",
    "abbreviation": "MINN",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/135.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/135-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/135.png",
        "contentDuplicateOf": "135-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "137": {
    "cfbdId": 137,
    "school": "Unresolved CFBD team 137",
    "abbreviation": "137",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/137.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "138": {
    "cfbdId": 138,
    "school": "Unresolved CFBD team 138",
    "abbreviation": "138",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/138.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "142": {
    "cfbdId": 142,
    "school": "Missouri",
    "abbreviation": "MIZ",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/142.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/142-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/142.png",
        "contentDuplicateOf": "142-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "143": {
    "cfbdId": 143,
    "school": "Unresolved CFBD team 143",
    "abbreviation": "143",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/143.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "145": {
    "cfbdId": 145,
    "school": "Ole Miss",
    "abbreviation": "MISS",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/145.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/145-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/145.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "149": {
    "cfbdId": 149,
    "school": "Unresolved CFBD team 149",
    "abbreviation": "149",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/149.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "150": {
    "cfbdId": 150,
    "school": "Duke",
    "abbreviation": "DUKE",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/150.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/150-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/150.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "151": {
    "cfbdId": 151,
    "school": "East Carolina",
    "abbreviation": "ECU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/151.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/151-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/151.png",
        "contentDuplicateOf": "151-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "152": {
    "cfbdId": 152,
    "school": "NC State",
    "abbreviation": "NCST",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/152.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/152-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/152.png",
        "contentDuplicateOf": "152-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "153": {
    "cfbdId": 153,
    "school": "North Carolina",
    "abbreviation": "UNC",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/153.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/153-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/153.png",
        "contentDuplicateOf": "153-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "154": {
    "cfbdId": 154,
    "school": "Wake Forest",
    "abbreviation": "WAKE",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/154.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/154-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/154.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "155": {
    "cfbdId": 155,
    "school": "Unresolved CFBD team 155",
    "abbreviation": "155",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/155.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "158": {
    "cfbdId": 158,
    "school": "Nebraska",
    "abbreviation": "NEB",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/158.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/158-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/158.png",
        "contentDuplicateOf": "158-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "159": {
    "cfbdId": 159,
    "school": "Unresolved CFBD team 159",
    "abbreviation": "159",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/159.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "162": {
    "cfbdId": 162,
    "school": "Unresolved CFBD team 162",
    "abbreviation": "162",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/162.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "163": {
    "cfbdId": 163,
    "school": "Unresolved CFBD team 163",
    "abbreviation": "163",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/163.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "164": {
    "cfbdId": 164,
    "school": "Rutgers",
    "abbreviation": "RUTG",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/164.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/164-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/164.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "166": {
    "cfbdId": 166,
    "school": "New Mexico State",
    "abbreviation": "NMSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/166.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/166-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/166.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "167": {
    "cfbdId": 167,
    "school": "New Mexico",
    "abbreviation": "UNM",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/167.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/167-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/167.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "171": {
    "cfbdId": 171,
    "school": "Unresolved CFBD team 171",
    "abbreviation": "171",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/171.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "172": {
    "cfbdId": 172,
    "school": "Unresolved CFBD team 172",
    "abbreviation": "172",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/172.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "173": {
    "cfbdId": 173,
    "school": "Unresolved CFBD team 173",
    "abbreviation": "173",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/173.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "183": {
    "cfbdId": 183,
    "school": "Syracuse",
    "abbreviation": "SYR",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/183.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/183-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/183.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "189": {
    "cfbdId": 189,
    "school": "Bowling Green",
    "abbreviation": "BGSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/189.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/189-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/189.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "193": {
    "cfbdId": 193,
    "school": "Miami (OH)",
    "abbreviation": "M-OH",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/193.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/193-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/193.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "194": {
    "cfbdId": 194,
    "school": "Ohio State",
    "abbreviation": "OSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/194.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/194-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/194.png",
        "contentDuplicateOf": "194-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "195": {
    "cfbdId": 195,
    "school": "Ohio",
    "abbreviation": "OHIO",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/195.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/195-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/195.png",
        "contentDuplicateOf": "195-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "196": {
    "cfbdId": 196,
    "school": "Unresolved CFBD team 196",
    "abbreviation": "196",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/196.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "197": {
    "cfbdId": 197,
    "school": "Oklahoma State",
    "abbreviation": "OKST",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/197.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/197-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/197.png",
        "contentDuplicateOf": "197-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "200": {
    "cfbdId": 200,
    "school": "Unresolved CFBD team 200",
    "abbreviation": "200",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/200.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "201": {
    "cfbdId": 201,
    "school": "Oklahoma",
    "abbreviation": "OKLA",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/201.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/201-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/201.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "202": {
    "cfbdId": 202,
    "school": "Tulsa",
    "abbreviation": "TLSA",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/202.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/202-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/202.png",
        "contentDuplicateOf": "202-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "204": {
    "cfbdId": 204,
    "school": "Oregon State",
    "abbreviation": "ORST",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/204.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/204-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/204.png",
        "contentDuplicateOf": "204-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "213": {
    "cfbdId": 213,
    "school": "Penn State",
    "abbreviation": "PSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/213.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/213-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/213.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "215": {
    "cfbdId": 215,
    "school": "Unresolved CFBD team 215",
    "abbreviation": "215",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/215.svg",
        "contentDuplicateOf": "213.svg"
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "218": {
    "cfbdId": 218,
    "school": "Temple",
    "abbreviation": "TEM",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/218.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/218-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/218.png",
        "contentDuplicateOf": "218-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "219": {
    "cfbdId": 219,
    "school": "Unresolved CFBD team 219",
    "abbreviation": "219",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/219.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "221": {
    "cfbdId": 221,
    "school": "Pittsburgh",
    "abbreviation": "PITT",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/221.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/221-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/221.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "222": {
    "cfbdId": 222,
    "school": "Unresolved CFBD team 222",
    "abbreviation": "222",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/222.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "225": {
    "cfbdId": 225,
    "school": "Unresolved CFBD team 225",
    "abbreviation": "225",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/225.svg",
        "contentDuplicateOf": "18.svg"
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "227": {
    "cfbdId": 227,
    "school": "Unresolved CFBD team 227",
    "abbreviation": "227",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/227.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "228": {
    "cfbdId": 228,
    "school": "Clemson",
    "abbreviation": "CLEM",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/228.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/228-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/228.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "231": {
    "cfbdId": 231,
    "school": "Unresolved CFBD team 231",
    "abbreviation": "231",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/231.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "233": {
    "cfbdId": 233,
    "school": "Unresolved CFBD team 233",
    "abbreviation": "233",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/233.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "235": {
    "cfbdId": 235,
    "school": "Memphis",
    "abbreviation": "MEM",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/235.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/235-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/235.png",
        "contentDuplicateOf": "235-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "236": {
    "cfbdId": 236,
    "school": "Unresolved CFBD team 236",
    "abbreviation": "236",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/236.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "237": {
    "cfbdId": 237,
    "school": "Unresolved CFBD team 237",
    "abbreviation": "237",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/237.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "238": {
    "cfbdId": 238,
    "school": "Vanderbilt",
    "abbreviation": "VAN",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/238.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/238-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/238.png",
        "contentDuplicateOf": "238-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "239": {
    "cfbdId": 239,
    "school": "Baylor",
    "abbreviation": "BAY",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/239.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/239-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/239.png",
        "contentDuplicateOf": "239-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "242": {
    "cfbdId": 242,
    "school": "Rice",
    "abbreviation": "RICE",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/242.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/242-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/242.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "245": {
    "cfbdId": 245,
    "school": "Texas A&M",
    "abbreviation": "TA&M",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/245.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/245-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/245.png",
        "contentDuplicateOf": "245-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "246": {
    "cfbdId": 246,
    "school": "Unresolved CFBD team 246",
    "abbreviation": "246",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/246.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "248": {
    "cfbdId": 248,
    "school": "Houston",
    "abbreviation": "HOU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/248.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/248-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/248.png",
        "contentDuplicateOf": "248-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "249": {
    "cfbdId": 249,
    "school": "North Texas",
    "abbreviation": "UNT",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/249.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/249-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/249.png",
        "contentDuplicateOf": "249-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "251": {
    "cfbdId": 251,
    "school": "Texas",
    "abbreviation": "TEX",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/251.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/251-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/251.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "252": {
    "cfbdId": 252,
    "school": "BYU",
    "abbreviation": "BYU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/252.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/252-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/252.png",
        "contentDuplicateOf": "252-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "254": {
    "cfbdId": 254,
    "school": "Utah",
    "abbreviation": "UTAH",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/254.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/254-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/254.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "256": {
    "cfbdId": 256,
    "school": "Unresolved CFBD team 256",
    "abbreviation": "256",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/256.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "257": {
    "cfbdId": 257,
    "school": "Unresolved CFBD team 257",
    "abbreviation": "257",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/257.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "258": {
    "cfbdId": 258,
    "school": "Virginia",
    "abbreviation": "UVA",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/258.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/258-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/258.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "259": {
    "cfbdId": 259,
    "school": "Virginia Tech",
    "abbreviation": "VT",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/259.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/259-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/259.png",
        "contentDuplicateOf": "259-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "264": {
    "cfbdId": 264,
    "school": "Washington",
    "abbreviation": "WASH",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/264.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/264-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/264.png",
        "contentDuplicateOf": "264-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "265": {
    "cfbdId": 265,
    "school": "Washington State",
    "abbreviation": "WSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/265.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/265-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/265.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "266": {
    "cfbdId": 266,
    "school": "Unresolved CFBD team 266",
    "abbreviation": "266",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/266.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "268": {
    "cfbdId": 268,
    "school": "Unresolved CFBD team 268",
    "abbreviation": "268",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/268.svg",
        "contentDuplicateOf": "75.svg"
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "272": {
    "cfbdId": 272,
    "school": "Unresolved CFBD team 272",
    "abbreviation": "272",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/272.svg",
        "contentDuplicateOf": "32.svg"
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "275": {
    "cfbdId": 275,
    "school": "Wisconsin",
    "abbreviation": "WISC",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/275.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/275-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/275.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "276": {
    "cfbdId": 276,
    "school": "Marshall",
    "abbreviation": "MRSH",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/276.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/276-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/276.png",
        "contentDuplicateOf": "276-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "277": {
    "cfbdId": 277,
    "school": "West Virginia",
    "abbreviation": "WVU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/277.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/277-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/277.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "278": {
    "cfbdId": 278,
    "school": "Fresno State",
    "abbreviation": "FRES",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/278.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/278-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/278.png",
        "contentDuplicateOf": "278-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "282": {
    "cfbdId": 282,
    "school": "Unresolved CFBD team 282",
    "abbreviation": "282",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/282.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "284": {
    "cfbdId": 284,
    "school": "Unresolved CFBD team 284",
    "abbreviation": "284",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/284.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "290": {
    "cfbdId": 290,
    "school": "Georgia Southern",
    "abbreviation": "GASO",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/290.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/290-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/290.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "294": {
    "cfbdId": 294,
    "school": "Unresolved CFBD team 294",
    "abbreviation": "294",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/294.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "295": {
    "cfbdId": 295,
    "school": "Old Dominion",
    "abbreviation": "ODU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/295.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/295-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/295.png",
        "contentDuplicateOf": "295-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "297": {
    "cfbdId": 297,
    "school": "Unresolved CFBD team 297",
    "abbreviation": "297",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/297.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "301": {
    "cfbdId": 301,
    "school": "Unresolved CFBD team 301",
    "abbreviation": "301",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/301.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "302": {
    "cfbdId": 302,
    "school": "Unresolved CFBD team 302",
    "abbreviation": "302",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/302.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "308": {
    "cfbdId": 308,
    "school": "Unresolved CFBD team 308",
    "abbreviation": "308",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/308.svg",
        "contentDuplicateOf": "246.svg"
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "309": {
    "cfbdId": 309,
    "school": "Louisiana",
    "abbreviation": "UL",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/309.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/309-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/309.png",
        "contentDuplicateOf": "309-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "311": {
    "cfbdId": 311,
    "school": "Unresolved CFBD team 311",
    "abbreviation": "311",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/311.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "314": {
    "cfbdId": 314,
    "school": "Unresolved CFBD team 314",
    "abbreviation": "314",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/314.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "317": {
    "cfbdId": 317,
    "school": "Unresolved CFBD team 317",
    "abbreviation": "317",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/317.svg",
        "contentDuplicateOf": "32.svg"
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "324": {
    "cfbdId": 324,
    "school": "Coastal Carolina",
    "abbreviation": "CCU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/324.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/324-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/324.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "326": {
    "cfbdId": 326,
    "school": "Texas State",
    "abbreviation": "TXST",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/326.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/326-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/326.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "328": {
    "cfbdId": 328,
    "school": "Utah State",
    "abbreviation": "USU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/328.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/328-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/328.png",
        "contentDuplicateOf": "328-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "333": {
    "cfbdId": 333,
    "school": "Alabama",
    "abbreviation": "ALA",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/333.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/333-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/333.png",
        "contentDuplicateOf": "333-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "338": {
    "cfbdId": 338,
    "school": "Unresolved CFBD team 338",
    "abbreviation": "338",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/338.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "341": {
    "cfbdId": 341,
    "school": "Unresolved CFBD team 341",
    "abbreviation": "341",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/341.svg",
        "contentDuplicateOf": "121.svg"
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "344": {
    "cfbdId": 344,
    "school": "Mississippi State",
    "abbreviation": "MSST",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/344.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/344-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/344.png",
        "contentDuplicateOf": "344-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "348": {
    "cfbdId": 348,
    "school": "Unresolved CFBD team 348",
    "abbreviation": "348",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/348.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "349": {
    "cfbdId": 349,
    "school": "Army",
    "abbreviation": "ARMY",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/349.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/349-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/349.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "351": {
    "cfbdId": 351,
    "school": "Unresolved CFBD team 351",
    "abbreviation": "351",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/351.svg",
        "contentDuplicateOf": "29.svg"
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "352": {
    "cfbdId": 352,
    "school": "Unresolved CFBD team 352",
    "abbreviation": "352",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/352.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "356": {
    "cfbdId": 356,
    "school": "Illinois",
    "abbreviation": "ILL",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/356.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/356-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/356.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2005": {
    "cfbdId": 2005,
    "school": "Air Force",
    "abbreviation": "AF",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2005.svg",
        "contentDuplicateOf": "114.svg"
      },
      "themedPng": {
        "path": "/assets/logos/2005-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2005.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2006": {
    "cfbdId": 2006,
    "school": "Akron",
    "abbreviation": "AKR",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2006.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2006-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2006.png",
        "contentDuplicateOf": "2006-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2026": {
    "cfbdId": 2026,
    "school": "Appalachian State",
    "abbreviation": "APP",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2026.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2026-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2026.png",
        "contentDuplicateOf": "2026-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2028": {
    "cfbdId": 2028,
    "school": "Unresolved CFBD team 2028",
    "abbreviation": "2028",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2028.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2032": {
    "cfbdId": 2032,
    "school": "Arkansas State",
    "abbreviation": "ARST",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2032.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2032-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2032.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2050": {
    "cfbdId": 2050,
    "school": "Ball State",
    "abbreviation": "BALL",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2050.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2050-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2050.png",
        "contentDuplicateOf": "2050-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2084": {
    "cfbdId": 2084,
    "school": "Buffalo",
    "abbreviation": "BUFF",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2084.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2084-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2084.png",
        "contentDuplicateOf": "2084-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2116": {
    "cfbdId": 2116,
    "school": "UCF",
    "abbreviation": "UCF",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2116.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2116-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2116.png",
        "contentDuplicateOf": "2116-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2117": {
    "cfbdId": 2117,
    "school": "Central Michigan",
    "abbreviation": "CMU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2117.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2117-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2117.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2129": {
    "cfbdId": 2129,
    "school": "Unresolved CFBD team 2129",
    "abbreviation": "2129",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2129.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2132": {
    "cfbdId": 2132,
    "school": "Cincinnati",
    "abbreviation": "CIN",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2132.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2132-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2132.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2199": {
    "cfbdId": 2199,
    "school": "Eastern Michigan",
    "abbreviation": "EMU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2199.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2199-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2199.png",
        "contentDuplicateOf": "2199-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2226": {
    "cfbdId": 2226,
    "school": "Florida Atlantic",
    "abbreviation": "FAU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2226.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2226-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2226.png",
        "contentDuplicateOf": "2226-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2229": {
    "cfbdId": 2229,
    "school": "FIU",
    "abbreviation": "FIU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2229.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2229-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2229.png",
        "contentDuplicateOf": "2229-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2247": {
    "cfbdId": 2247,
    "school": "Georgia State",
    "abbreviation": "GAST",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2247.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2247-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2247.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2248": {
    "cfbdId": 2248,
    "school": "Unresolved CFBD team 2248",
    "abbreviation": "2248",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2248.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2294": {
    "cfbdId": 2294,
    "school": "Iowa",
    "abbreviation": "IOWA",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2294.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2294-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2294.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2305": {
    "cfbdId": 2305,
    "school": "Kansas",
    "abbreviation": "KU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2305.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2305-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2305.png",
        "contentDuplicateOf": "2305-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2306": {
    "cfbdId": 2306,
    "school": "Kansas State",
    "abbreviation": "KSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2306.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2306-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2306.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2309": {
    "cfbdId": 2309,
    "school": "Kent State",
    "abbreviation": "KENT",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2309.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2309-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2309.png",
        "contentDuplicateOf": "2309-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2335": {
    "cfbdId": 2335,
    "school": "Liberty",
    "abbreviation": "LIB",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2335.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2335-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2335.png",
        "contentDuplicateOf": "2335-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2348": {
    "cfbdId": 2348,
    "school": "Louisiana Tech",
    "abbreviation": "LT",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2348.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2348-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2348.png",
        "contentDuplicateOf": "2348-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2390": {
    "cfbdId": 2390,
    "school": "Miami (FL)",
    "abbreviation": "MIA",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2390.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2390-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2390.png",
        "contentDuplicateOf": "2390-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2392": {
    "cfbdId": 2392,
    "school": "Unresolved CFBD team 2392",
    "abbreviation": "2392",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2392.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2393": {
    "cfbdId": 2393,
    "school": "Middle Tennessee",
    "abbreviation": "MTSU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2393.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2393-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2393.png",
        "contentDuplicateOf": "2393-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2426": {
    "cfbdId": 2426,
    "school": "Navy",
    "abbreviation": "NAVY",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2426.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2426-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2426.png",
        "contentDuplicateOf": "2426-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2429": {
    "cfbdId": 2429,
    "school": "Charlotte",
    "abbreviation": "CHAR",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2429.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2429-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2429.png",
        "contentDuplicateOf": "2429-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2433": {
    "cfbdId": 2433,
    "school": "Louisiana–Monroe",
    "abbreviation": "ULM",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2433.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2433-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2433.png",
        "contentDuplicateOf": "2433-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2439": {
    "cfbdId": 2439,
    "school": "UNLV",
    "abbreviation": "UNLV",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2439.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2439-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2439.png",
        "contentDuplicateOf": "2439-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2440": {
    "cfbdId": 2440,
    "school": "Nevada",
    "abbreviation": "NEV",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2440.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2440-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2440.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2459": {
    "cfbdId": 2459,
    "school": "Northern Illinois",
    "abbreviation": "UNI",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2459.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2459-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2459.png",
        "contentDuplicateOf": "2459-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2483": {
    "cfbdId": 2483,
    "school": "Oregon",
    "abbreviation": "ORE",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2483.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2483-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2483.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2502": {
    "cfbdId": 2502,
    "school": "Unresolved CFBD team 2502",
    "abbreviation": "2502",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2502.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2509": {
    "cfbdId": 2509,
    "school": "Purdue",
    "abbreviation": "PUR",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2509.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2509-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2509.png",
        "contentDuplicateOf": "2509-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2534": {
    "cfbdId": 2534,
    "school": "Unresolved CFBD team 2534",
    "abbreviation": "2534",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2534.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2567": {
    "cfbdId": 2567,
    "school": "SMU",
    "abbreviation": "SMU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2567.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2567-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2567.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2572": {
    "cfbdId": 2572,
    "school": "Southern Miss",
    "abbreviation": "USM",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2572.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2572-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2572.png",
        "contentDuplicateOf": "2572-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2579": {
    "cfbdId": 2579,
    "school": "South Carolina",
    "abbreviation": "SC",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2579.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2579-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2579.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2623": {
    "cfbdId": 2623,
    "school": "Unresolved CFBD team 2623",
    "abbreviation": "2623",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2623.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2628": {
    "cfbdId": 2628,
    "school": "TCU",
    "abbreviation": "TCU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2628.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2628-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2628.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2633": {
    "cfbdId": 2633,
    "school": "Tennessee",
    "abbreviation": "TENN",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2633.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2633-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2633.png",
        "contentDuplicateOf": "2633-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2635": {
    "cfbdId": 2635,
    "school": "Unresolved CFBD team 2635",
    "abbreviation": "2635",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2635.svg",
        "contentDuplicateOf": null
      },
      "themedPng": null,
      "basePng": null
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2636": {
    "cfbdId": 2636,
    "school": "UTSA",
    "abbreviation": "UTSA",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2636.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2636-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2636.png",
        "contentDuplicateOf": "2636-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2638": {
    "cfbdId": 2638,
    "school": "UTEP",
    "abbreviation": "UTEP",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2638.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2638-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2638.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2641": {
    "cfbdId": 2641,
    "school": "Texas Tech",
    "abbreviation": "TTU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2641.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2641-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2641.png",
        "contentDuplicateOf": "2641-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2649": {
    "cfbdId": 2649,
    "school": "Toledo",
    "abbreviation": "TOL",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2649.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2649-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2649.png",
        "contentDuplicateOf": null
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2653": {
    "cfbdId": 2653,
    "school": "Troy",
    "abbreviation": "TROY",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2653.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2653-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2653.png",
        "contentDuplicateOf": "2653-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2655": {
    "cfbdId": 2655,
    "school": "Tulane",
    "abbreviation": "TULN",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2655.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2655-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2655.png",
        "contentDuplicateOf": "2655-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2711": {
    "cfbdId": 2711,
    "school": "Western Michigan",
    "abbreviation": "WMU",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2711.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2711-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2711.png",
        "contentDuplicateOf": "2711-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  },
  "2751": {
    "cfbdId": 2751,
    "school": "Wyoming",
    "abbreviation": "WYO",
    "colors": {
      "primary": null,
      "secondary": null
    },
    "contrast": {
      "primary": null,
      "secondary": null
    },
    "assets": {
      "svg": {
        "path": "/assets/logos/2751.svg",
        "contentDuplicateOf": null
      },
      "themedPng": {
        "path": "/assets/logos/2751-dark.png",
        "contentDuplicateOf": null
      },
      "basePng": {
        "path": "/assets/logos/2751.png",
        "contentDuplicateOf": "2751-dark.png"
      }
    },
    "reviewStatus": "legacy-approved",
    "presentation": {
      "outline": "adaptive",
      "backgroundOverride": null,
      "approvedOverride": false,
      "overrideReason": null
    }
  }
};
